module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaAQMAAACThN6NAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRFPDw8AAAACPNshwAAAAJ0Uk5TMwCC+KgIAAAAGUlEQVR4nGNgPvCBgQEn8f///wPoBJV1AABe9jx/iYRDpwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/base-title-icon.png
// module id = UYzb
// module chunks = 0